import { registerPlugin } from '@capacitor/core';
const TextZoom = registerPlugin('TextZoom', {
    ios: () => import('./ios').then(m => new m.TextZoomIOS()),
});
export * from './definitions';
export { TextZoom };
//# sourceMappingURL=index.js.map